import React, { useEffect, useRef, useState } from 'react'
import { KTIcon } from '../../../_metronic/helpers';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import moment from "moment";
import '../../../common/rsuite-datepicker.css';
import Select, { StylesConfig } from 'react-select';
import { format } from 'date-fns';
import fetchAPI from '../../../common/fetchAPI';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
    getTimeEntryArchiveForDatatableAsync, resetSelectedRecordObjectInState, deleteAccountEmployeeTimeEntryAsync,
    setDateRangeValue, setOptionApprovedValue, setOptionClientNameValue, setOptionEmployeeNameValue, setOptionProjectTaskValue, setOptionProjectValue,setOptionTimeEntryTypeValue
} from "./TimeEntryArchiveSlice";
import DatePickerRanges from '../../../common/DatePickerRanges';

interface DropdownItem {
    value: number;
    label: string;
}

const TimeEntryArchiveOffCanvas = (props: any) => {
    const { t } = props;
    
    const { sessionAccountEmployeeId,maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector(state => state.globalState);
    const AccountEmployeeId: any = sessionAccountEmployeeId;
    //const { onDateRangeChange, onhandleClientNameChange, onhandleEmployeeNameChange, onhandleProjectChange, onhandleProjectTaskChange, onhandleApprovedChange, onhandleApplyFilterOnClickEvent, onhandleResetFiltersOnClickEvent } = props;
    const dispatch = useAppDispatch();
    const { timeEntryArchiveList, isReload, currentPage, pageSize, isLoading, totalItems, start, search, recordsFiltered, timeEntryArchiveCheckedIds } = useAppSelector((state) => state.timeEntryArchive);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [clientNameArray, setClientNameArray] = useState<any | ''>([]);
    const [selectedClientNameOptionDropDown, setSelectedClientNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
    const [clientSearch, setClientSearch] = useState<string>('');
    const [clientPage, setClientPage] = useState(1);
    const [clientLoading, setClientLoading] = useState(false);
    const [hasMoreClient, setHasMoreClient] = useState(true);

    const [EmployeeNameArray, setEmployeeNameArray] = useState<any | ''>([]);
    const [selectedEmployeeNameOptionDropDown, setSelectedEmployeeNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });

    const [ProjectArray, setProjectArray] = useState<any | ''>([]);
    const [selectedProjectOptionDropDown, setSelectedProjectOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });

    const [ProjectTaskArray, setProjectTaskArray] = useState<any | ''>([]);
    const [selectedProjectTaskOptionDropDown, setSelectedProjectTaskOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });

    const [ApprovedArray, setApprovedArray] = useState<any | ''>([]);
    const [selectedApprovedOptionDropDown, setSelectedApprovedOptionDropDown] = useState<{ [object: string]: any }>({ value: '-1', label: 'Both' });
   
    const [timeEntryTypeArray, setTimeEntryTypeArray] = useState<any | ''>([]);
    const [selectedTimeEntryTypeOptionDropDown, setSelectedTimeEntryTypeOptionDropDown] = useState<{ [object: string]: any }>({ value: '-1', label: 'Both' });

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    const [selectedEmployee, setselectedEmployee] =  useState<{ [object: string]: any }>({ value: '0', label: 'All' });
    const [loading, setLoading] = useState(false);
    const [hasMoreTL, setHasMoreTL] = useState(true);
    const [dataTL, setDataTL] = useState<DropdownItem[]>([]);
    const [hasMoreProject, setHasMoreProject] = useState(true);
    const [pageProjects, setPageProjects] = useState(1);
    const [dataProject, setDataProject] = useState<DropdownItem[]>([]);
    const [page, setPage] = useState(1);
    const [searchEmp, setSearchEmp] = useState<string>('');
    const [searchProjects, setSearchProject] = useState<string>('');
    const [searchTasks, setSearchTasks] = useState<string>('');
    const [hasMoreTasks, setHasMoreTasks] = useState(true);
    const [pageTasks, setPageTasks] = useState(1);
    const [dataTasks, setDataTasks] = useState<DropdownItem[]>([]);

    useEffect(() => {
        let ApprovedArray = [
            { value: '-1', label: 'Both' },
            { value: '1', label: 'Approved' },
            { value: '0', label: 'Not Approved' },
        ]
        setApprovedArray(ApprovedArray);

        let entryTypeArray = [
        { value: '-1', label: 'Both' },
        { value: '0', label: 'Timesheet' },
        { value: '1', label: 'Time Off' },
       ]
        setTimeEntryTypeArray(entryTypeArray);
    }, [])

    useEffect(() => {
        //getClientNameAsync();
        fetchCientData(clientPage, clientSearch);
        getEmployeeNameAsync();
        // getProjectAsync();
        fetchProjectsData();
        // getProjectTaskAsync();
        fetchTasksData();
    }, [])

    const fetchCientData = async (pageNum: any, search: string) => {
        setClientLoading(true);
        try {
            const searchParam = search ? `&search=${search}` : "";
            const response: any = await fetchAPI(`api/V2/Clients/Dropdown/0?page=${pageNum}${searchParam}`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            if (pageNum === 1) {
                transformedData.unshift({ value: '0', label: 'All' });
                setSelectedClientNameOptionDropDown({ value: '0', label: 'All' });
            }   

            const newItems = transformedData.filter((item: any) => !clientNameArray.some((existingItem: any) => existingItem.value === item.value));
            setClientNameArray((prevData: any) => [...prevData, ...newItems]);
            setHasMoreClient(newItems.length > 0);

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setClientLoading(false);
        }
    };
    // useEffect(() => {
    //     const delayDebounceFn = setTimeout(() => {
    //         fetchCientData(clientPage, clientSearch);
    //     }, 500);
    //     return () => clearTimeout(delayDebounceFn);
    // }, [clientPage, clientSearch]);

    const handleClientNameChange = (data: any) => {
        const { value, label } = data;
        setSelectedClientNameOptionDropDown({ value: value, label: label });
        dispatch(setOptionClientNameValue({ value: value, label: label }));      
        if (data.value === '0') {
            setSelectedProjectOptionDropDown({ value: '0', label: 'All' });
        }     
       
        setDataProject([]); 
        fetchProjectsData(1, searchProjects, value);
       // getProjectAsync(data.value);
        //fetchProjectsData(pageProjects, searchProjects, data.value);
       

    };
    // const handleClientNameChange = (data: any) => {
    //     const { value, label } = data;
    //     setSelectedClientNameOptionDropDown({ value: value, label: label });
    //     dispatch(setOptionClientNameValue({ value: value, label: label }));
    //     //onhandleClientNameChange({ value: value, label: label });

    // };

    const handleClientInputChange = (inputValue: string) => {
        setClientSearch(inputValue);
       
    };

    const customMenuListClient = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleClientScroll(e);
        };
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    };

    const handleClientScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        // if (bottom && hasMoreClient && !clientLoading) {
        //     setClientPage((prevPage) => prevPage + 1);
        // }
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMoreClient && !clientLoading) {
            setClientPage((prevPage) => prevPage + 1);
        }
    };


    const fetchData = async (pageNum: any, searchEmp: string) => {
        setLoading(true);
        try {
            const searchParam = searchEmp ? `&search=${searchEmp}` : "";
            const response: any = await fetchAPI(
                `api/V2/Employees/CurrentActiveNameAndIdForDropdown/${sessionAccountEmployeeId}?page=${pageNum}${searchParam}`,
                "GET",
                "",
                true
            );
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            if (pageNum === 1) {
                transformedData.unshift({ value: '0', label: 'All' });
                setselectedEmployee({ value: '0', label: 'All' });
            }    
            const newItemsTL = transformedData.filter(
                (item: any) => !dataTL.some((existingItem: any) => existingItem.value === item.value)
            );
            setDataTL((prevData) => [...prevData, ...newItemsTL]);
            setHasMoreTL(newItemsTL.length > 0);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        fetchData(page, searchEmp);
    }, [page, searchEmp]);
    
    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        if (bottom && hasMoreTL && !loading) {
            setPage((prevPage) => prevPage + 1);
        }
    };
    

    const customMenuList = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }



    const fetchProjectsData = async (pageNum: any = 1 , searchProjects: string = '', AccountClientId : any = 0) => {
        setLoading(true);
        try {
            const searchParam = searchProjects ? `&search=${searchProjects}` : "";

            const queryParams = new URLSearchParams();
            queryParams.append('AccountEmployeeId', AccountEmployeeId);
            queryParams.append('IsTemplate', 'false');
            queryParams.append('AccountClientId', AccountClientId !== 0 ? AccountClientId : 0);
            queryParams.append('page', pageNum);
            queryParams.append('search', searchParam);
           
            const url = `api/V2/Projects/NameAndIdByAccountId/1?${queryParams.toString()}`;
            const response = await fetchAPI(url, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();

           
            const transformedData = json.Data.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            // if (pageNum === 1) {
                transformedData.unshift({ value: '0', label: 'All' });
                setSelectedProjectOptionDropDown({ value: '0', label: 'All' });
            // }    
            const newItemsProject = transformedData.filter(
                (item: any) => !dataProject.some((existingItem: any) => existingItem.value === item.value)
            );
            // setDataProject((prevData) => [...prevData, ...newItemsProject]);
            setDataProject(transformedData);
            setHasMoreProject(newItemsProject.length > 0);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    
    // useEffect(() => {
    //     fetchProjectsData(pageProjects, searchProjects);
    // }, [pageProjects, searchProjects]);
    const handleScrollProjects = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMoreProject && !loading) {
            setPageProjects((prevPage) => prevPage + 1);
        }
    };
    const customMenuProjectsList = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleScrollProjects(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }


    const fetchTasksData = async (pageNum: any = 1 , searchTasks: string = '', AccountProjectId : any = 0) => {
        setLoading(true);
        try {
            const searchParam = searchTasks ? `&search=${searchTasks}` : "";

            const queryParams = new URLSearchParams();
            queryParams.append('AccountProjectId', AccountProjectId !== 0 ? AccountProjectId : 0);
            queryParams.append('page', pageNum);
            queryParams.append('search', searchParam);
           
            const url = `api/V2/Tasks/ProjectTasksForDropdown/1?${queryParams.toString()}`;
            const response = await fetchAPI(url, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();

           
            const transformedData = json.Data.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            //if (pageNum === 1) {
                transformedData.unshift({ value: '0', label: 'All' });
                setSelectedProjectTaskOptionDropDown({ value: '0', label: 'All' });
            //}    
            const newItemsTasks = transformedData.filter(
                (item: any) => !dataTasks.some((existingItem: any) => existingItem.value === item.value)
            );
            // setDataTasks((prevData) => [...prevData, ...newItemsTasks]);
            setDataTasks(transformedData);
            setHasMoreTasks(newItemsTasks.length > 0);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false); 
        }
    };
    
    // useEffect(() => {
    //     fetchTasksData(pageTasks, searchTasks);
    // }, [pageTasks, searchTasks]);
   
    const handleScrollTasks = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMoreTasks && !loading) {
            setPageTasks((prevPage) => prevPage + 1);
        }
    };
    const customMenuTasksList = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleScrollTasks(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }




    const getEmployeeNameAsync = async () => {
        const response: any = await fetchAPI(`api/V2/Employees/CurrentActiveNameAndIdForDropdown/${sessionAccountEmployeeId}?page=${1}&search=${""}`, "GET", "", true);
        const json = await response.json();
        const transformedData = json.items.map((item: any) => ({
            value: item.id,
            label: item.text,
        }));       
        setselectedEmployee({ value: '0', label: 'All' });
    }


    const handleInputEmp = (inputValue: string) => {
        setSearchEmp(inputValue);
    }

    const handleInputProject = (inputValue: string) => {
        setSearchProject(inputValue);
    }

    const handleInputTask = (inputValue: string) => {
        setSearchTasks(inputValue);
    }



    const getProjectAsync = async (AccountClientId: any = 0) => {
        
        const queryParams = new URLSearchParams();
        queryParams.append('AccountEmployeeId', AccountEmployeeId);
        queryParams.append('IsTemplate', 'false');
        queryParams.append('AccountClientId', AccountClientId !== 0 ? AccountClientId : 0);
        queryParams.append('page', '1');

        const url = `api/V2/Projects/NameAndIdByAccountId/1?${queryParams.toString()}`;
        const response = await fetchAPI(url, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        json.Data.items.map((item: any) => {
            item.value = item.id;
            item.label = item.text;
            delete item.id;
            delete item.text;
        });
        json.Data.items.unshift({ value: '0', label: 'All' })

        setProjectArray(json.Data.items);
    }


    const getProjectTaskAsync = async (AccountProjectId: any = 0) => {
        const queryParams = new URLSearchParams();
        queryParams.append('AccountProjectId', AccountProjectId !== 0 ? AccountProjectId : 0);
        queryParams.append('page', '1');

        const url = `api/V2/Tasks/ProjectTasksForDropdown/1?${queryParams.toString()}`;
        const response = await fetchAPI(url, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        json.Data.items.map((item: any) => {
            item.value = item.id;
            item.label = item.text;
            delete item.id;
            delete item.text;
        });
        json.Data.items.unshift({ value: '0', label: 'All' })

        setProjectTaskArray(json.Data.items);
    }

    const handleDateRangeChange = (value: any) => {
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        setStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
        dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
    };


    const handleEmployeeNameChange = (data: any) => {
        const { value, label } = data;
        setSelectedEmployeeNameOptionDropDown({ value: value, label: label });
        dispatch(setOptionEmployeeNameValue({ value: value, label: label }));
        setselectedEmployee(data);
        //onhandleEmployeeNameChange({ value: value, label: label });

    };
    const handleProjectChange = (data: any) => {
        const { value, label } = data;
        setSelectedProjectOptionDropDown({ value: value, label: label });
        dispatch(setOptionProjectValue({ value: value, label: label }));        
        if (data.value === '0') {
            setSelectedProjectTaskOptionDropDown({ value: '0', label: 'All' });
        }
        //getProjectTaskAsync(data.value);      
        setDataTasks([]); 
        fetchTasksData(1, searchTasks, value);
    };
    const handleProjectTaskChange = (data: any) => {
        const { value, label } = data;
        setSelectedProjectTaskOptionDropDown({ value: value, label: label });
        dispatch(setOptionProjectTaskValue({ value: value, label: label }));
        //onhandleProjectTaskChange({ value: value, label: label });

    };
    const handleApprovedChange = (data: any) => {
        const { value, label } = data;
        setSelectedApprovedOptionDropDown({ value: value, label: label });
        dispatch(setOptionApprovedValue({ value: value, label: label }));
       

    };

    const handleTimeEntryTypeChange = (data: any) => {
        const { value, label } = data;
        setSelectedTimeEntryTypeOptionDropDown({ value: value, label: label });
        dispatch(setOptionTimeEntryTypeValue({ value: value, label: label }));
    };

    const handleApplyFilterOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        dispatch(resetSelectedRecordObjectInState());
        let SearchParamsValues = `${selectedClientNameOptionDropDown.value},${selectedEmployee.value},${selectedProjectOptionDropDown.value},${selectedProjectTaskOptionDropDown.value},${selectedApprovedOptionDropDown.value},${selectedTimeEntryTypeOptionDropDown.value},${false},
       ${moment(startDate).format(dateInsertionFormat)},${moment(endDate).format(dateInsertionFormat)},${selectedClientNameOptionDropDown.label},${selectedEmployee.label},${selectedProjectOptionDropDown.label},${selectedProjectTaskOptionDropDown.label},${selectedTimeEntryTypeOptionDropDown.label}`;
        dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: 0, SearchParamsValues: SearchParamsValues, search: search }));
        //onhandleApplyFilterOnClickEvent();

    };
    const handleResetFiltersOnClickEvent = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        setSelectedClientNameOptionDropDown({ value: '0', label: 'All' });
        setselectedEmployee({ value: '0', label: 'All' });
        setSelectedProjectOptionDropDown({ value: '0', label: 'All' });
        setSelectedProjectTaskOptionDropDown({ value: '0', label: 'All' });
        setSelectedApprovedOptionDropDown({ value: '-1', label: 'Both' });
        //onhandleResetFiltersOnClickEvent();
        dispatch(resetSelectedRecordObjectInState());
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }

    };

    return (
        <>

            {isLoading && <Loader />}

            <div className='card-body'>
                <div className='row' >
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Date Range')} */}
                            {getValueFromResource('Date Range',dispatch, t)}
                            </label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                ranges={DatePickerRanges() }
                                value={[startDate, endDate]}
                                // placeholder='Please Select Date Range'
                                placeholder={displayedRange}
                                character={' - '}
                                // placement="auto"
                                // placement="bottomStart"
                                cleanable={false}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                </div>


                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Client Name')} */}
                            {getValueFromResource('Client Name',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedClientNameOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleClientNameChange}
                                options={clientNameArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                // onInputChange={handleClientInputChange}
                                // components={{ MenuList: customMenuListClient }}
                            />
                        </div>
                    </div>
                </div>


                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name',dispatch, t)}
                            </label>
                        <div>
                             <Select
                                                        value={selectedEmployee}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="employeeArray"
                                                        onChange={handleEmployeeNameChange}
                                                        options={dataTL}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        // onInputChange={handleInputEmp}
                                                        components={{ MenuList: customMenuList }}
                                                    />
                        </div>
                    </div>
                </div>

                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Project')} */}
                            {getValueFromResource('Project',dispatch, t)}
                            </label>
                        <div>
                             <Select
                                                        value={selectedProjectOptionDropDown}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="projectsArray"
                                                        onChange={handleProjectChange}
                                                        options={dataProject}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        // onInputChange={handleInputProject}
                                                        // components={{ MenuList: customMenuProjectsList }}
                                                    />
                        </div>
                    </div>
                </div>

                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Project Task')} */}
                            {getValueFromResource('Project Task',dispatch, t)}
                            </label>
                        <div>
                             <Select
                                                        value={selectedProjectTaskOptionDropDown}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="taskArray"
                                                        onChange={handleProjectTaskChange}
                                                        options={dataTasks}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        // onInputChange={handleInputTask}
                                                        // components={{ MenuList: customMenuTasksList }}
                                                    />
                        </div>
                    </div>
                </div>

                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Approved')} */}
                            {getValueFromResource('Approved',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedApprovedOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="ApprovedList"
                                onChange={handleApprovedChange}
                                options={ApprovedArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                menuPlacement='top'
                            />
                        </div>
                    </div>

                </div>

               
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {getValueFromResource('Entry Type', dispatch, t)}
                        </label>
                        <div>
                            <Select
                                value={selectedTimeEntryTypeOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="TimeEntryTypeList"
                                onChange={handleTimeEntryTypeChange}
                                options={timeEntryTypeArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                menuPlacement='top' 
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    
                    <button
                        type='button'
                        ref={closeButtonRef}
                        style={{ display: 'none' }}
                        id='kt_OffCanvas_close'
                    >
                       
                        {getValueFromResource('Apply Filter',dispatch, t)}
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm me-2 fs-7"
                        data-kt-element='send' onClick={handleResetFiltersOnClickEvent}
                    >
                       
                        {getValueFromResource('Clear Filters',dispatch, t)}

                    </button>

                    <button
                        type="button"
                        data-kt-element='send'
                        className="btn btn-primary btn-sm fs-7"
                        onClick={handleApplyFilterOnClickEvent}
                    >
                       
                        {getValueFromResource('Apply Filters',dispatch, t)}
                    </button>
                    
                </div>
            </div>
        </>

    )

}


export default TimeEntryArchiveOffCanvas